/*eslint-disable*/
import {
  addClass,
  removeClass,
  removeNodes,
  sum,
  square,
  getSrc,
  decryptAES,
  encryptAES,
} from './utils';
import { captchaCreate, captchaCheck } from '@/servies/index.js';

const APPID = 8;
const KEY = '123risk456ksir78';
const VERIFY_TYPE = 'SLIDE_NEW';

export default class MgCaptcha {
  constructor() {
    this.token = '';
    this.isPainting = false;
    this.aesKey = '';

    this.defaults = {
      element: null,
      mode: 'pop', //弹出式pop，固定fixed
      width: '300px',
      height: '200px',
      overlayClose: true,
      onReady: () => {},
      onSuccess: () => {},
      onFail: () => {},
      onRefresh: () => {},
      onClose: () => {},
      onReset: () => {},
    };
  }

  get slideMode() {
    return this.type === 'SLIDE_NEW';
  }

  async init(options) {
    if (this.isPainting) return;

    // 初始化DOM
    this.mergeOptions(options);

    // 事件绑定
    this.bindEvents();

    // 生成校验码
    this.createCaptcha();
  }

  // 合并参数，生成dom
  mergeOptions(options) {
    this.options = Object.assign(this.defaults, {}, options);

    this.clickResult = [];
    this.$element = document.getElementById('CaptchaDragEle');

    this.captchaEle = this.$element.querySelector('#captchaEle');
    this.imgContainer = this.captchaEle.querySelector('.imgContainer');
    this.refreshIcon = this.captchaEle.querySelector('.refreshIcon');
    this.verifyTip = this.captchaEle.querySelector('.verifyTip');
    this.lodingBox = this.captchaEle.querySelector('.lodingBox');

    this.sliderContainer = this.captchaEle.querySelector('.sliderContainer');
    this.slider = this.captchaEle.querySelector('.slider');
    this.shadowImg = this.captchaEle.querySelector('#shadow_img');
    this.blockImg = this.captchaEle.querySelector('#block_img');
    this.closeBtn = document.getElementById('closeSlider');

    if (this.$element) {
      this.resetPosition();
      this.$element.style.display = 'block';
    }
  }

  // 绑定事件
  bindEvents() {
    this.captchaEle.onselectstart = () => false;

    this.imgContainer.onclick = e => {
      e.preventDefault();
      this.refresh();
    };

    this.closeBtn.onclick = e => {
      e.preventDefault();
      this.close();
    };

    this.refreshIcon.onclick = e => {
      e.preventDefault();
      this.refresh();
    };

    let originX,
      originY,
      trail = [],
      isMouseDown = false;

    this.handleDragStart = function (e) {
      e.preventDefault();
      originX = e.clientX || e.touches[0].clientX;
      originY = e.clientY || e.touches[0].clientY;
      isMouseDown = true;
    };

    this.handleDragMove = e => {
      if (!isMouseDown) return false;
      e.preventDefault();
      const eventX = e.clientX || e?.touches[0]?.pageX;
      const eventY = e.clientY || e?.touches[0]?.pageY;
      const moveX = eventX - originX;
      const moveY = eventY - originY;

      // 44 = 滑块宽度-->blick img width，这里需要优化下
      if (moveX < 0 || moveX + 44 >= parseInt(this.options.width)) return false;
      this.slider.style.left = moveX + 'px';
      this.blockImg.style.left = moveX + 'px';

      addClass(this.sliderContainer, 'sliderContainer_active');
      trail.push(moveY);
    };

    this.handleDragEnd = e => {
      if (!isMouseDown) return false;
      isMouseDown = false;
      const eventX = e.clientX || e.changedTouches[0].clientX;
      if (eventX == originX) return false;
      this.trail = trail;
      this.verify();
    };

    if (this.slideMode) {
      this.slider.addEventListener('mousedown', this.handleDragStart, {
        passive: false,
      });
      this.slider.addEventListener('touchstart', this.handleDragStart, {
        passive: false,
      });
      this.blockImg.addEventListener('mousedown', this.handleDragStart, {
        passive: false,
      });
      this.blockImg.addEventListener('touchstart', this.handleDragStart, {
        passive: false,
      });
    }
    document.addEventListener('mousemove', this.handleDragMove, {
      passive: false,
    });
    document.addEventListener('touchmove', this.handleDragMove, {
      passive: false,
    });
    document.addEventListener('mouseup', this.handleDragEnd, {
      passive: false,
    });
    document.addEventListener('touchend', this.handleDragEnd, {
      passive: false,
    });
  }

  // 获取并生成验证码
  createCaptcha() {
    try {
      // 获取验证码getCaptchaImage
      captchaCreate({
        suid: this.options.suid,
        reqId: this.options.reqId,
        uuid: this.options.uuid,
        type: VERIFY_TYPE,
        appid: APPID,
        did: this.options.did,
      }).then(res => {
        if (res && res.data.code) {
          if (res.data.code === 200) {
            let data = res.data;

            const { encKey, imageVerificationInfo } = res.data.data;
            const realKey = decryptAES(encKey, KEY);
            this.aesKey = realKey;
            const decryptInfo = decryptAES(imageVerificationInfo, realKey);
            // const { cutoutImage, shadeImage, percentageY } =
            //   JSON.parse(decryptInfo);
            // debugger;
            console.log(JSON.parse(decryptInfo));
            this.captchaImage = JSON.parse(decryptInfo);

            this.type = this.captchaImage.type.toUpperCase(); // 根据接口返回的类型来确定验证码最终类型
            this.createCaptchaDom();
          } else if (res.data.code !== 200 && res.action === 'close') {
            addClass(this.sliderContainer, 'sliderContainer_fail');
            typeof this.options.onFail === 'function' &&
              this.options.onFail(res.msg);

            setTimeout(() => {
              this.close();
            }, 800);
          } else {
            this.isPainting = false;
            typeof this.options.onFail === 'function' &&
              this.options.onFail(res.msg);
            // throw new Error('获取验证码图片失败')
            return;
          }
        } else {
          // 服务挂掉，接口返回失败
          throw new Error('接口返回失败，请稍后重试');
        }
      });
    } catch (error) {
      this.isPainting = false;
      // 服务挂掉，接口返回失败
      typeof this.options.onFail === 'function' &&
        this.options.onFail({
          err: error,
          msg: 'network request error',
          code: 12306,
        });
    }
  }

  // 绘制验证码
  createCaptchaDom() {
    this.createSlideCaptcha();
  }

  // 滑动验证码
  createSlideCaptcha() {
    this.isPainting = true; // 正在绘制
    // 先清除子节点
    if (this.imgContainer) {
      removeNodes(this.imgContainer);
    }
    const shadowImgSrc = getSrc(this.type, this.captchaImage.shadeImage);

    if (!shadowImgSrc) return;
    const shadowImg = new Image();
    shadowImg.src = shadowImgSrc;
    // shadowImg.onload = () => {
    const existShadowImg = document.getElementById(
      '#shanhaiRiskCapShadowImg_2025'
    );
    if (existShadowImg) return; // 如果已经存在则不进行绘制,避免出现多张验证码图片
    shadowImg.id = 'shanhaiRiskCapShadowImg_2025';

    // 这里记录原图宽高，滑动的距离要缩放
    this.shadowImgOriginSize = {
      width: shadowImg.width,
      height: shadowImg.height,
    };
    this.shadowImgScaleX = (
      shadowImg.width / parseInt(this.options.width)
    ).toFixed(5);
    this.shadowImgScaleY = (
      shadowImg.height / parseInt(this.options.height)
    ).toFixed(5);
    addClass(shadowImg, 'shadowImg');
    shadowImg.setAttribute('style', `height:${this.options.height};`);
    this.imgContainer.appendChild(shadowImg);

    const blockImg = new Image();
    blockImg.src = getSrc(this.type, this.captchaImage.cutoutImage);

    // .onload = () => {
    const existBlockImg = document.getElementById('#mgtvRiskCapShadowImg_2021');
    if (existBlockImg) return; // 如果已经存在则不进行绘制,避免出现多张验证码图片
    blockImg.id = 'mgtvRiskCapShadowImg_2021';

    this.blockImgOriginSize = {
      width: blockImg.width,
      height: blockImg.height,
    };

    const w = blockImg.width / this.shadowImgScaleX;
    const h = blockImg.height / this.shadowImgScaleY;
    const top = this.captchaImage.y / this.shadowImgScaleY;
    // 在这里设置图片滑块垂直位置
    blockImg.setAttribute(
      'style',
      `width: ${w.toFixed(5)}px;height:${h}px;top: ${top}px`
    );

    addClass(blockImg, 'blockImg');
    this.imgContainer.appendChild(blockImg);

    this.isPainting = false; // 绘制完成
    typeof this.options.onReady === 'function' && this.options.onReady();
    // };

    this.blockImg = blockImg;
    this.imgContainer.style.visibility = 'visible';
    this.lodingBox.style.display = 'none';
    // };
    this.shadowImg = shadowImg;
  }

  // 滑动验证逻辑
  async verify() {
    const arr = this.trail; // 拖动时y轴的移动距离
    const average = arr.reduce(sum) / arr.length;
    const deviations = arr.map(x => x - average);
    const stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length);
    const left = parseInt(this.blockImg.style.left);
    const realLeft = (left * this.shadowImgScaleX).toFixed(0); // 因为验证码图片大小重置，所以水平移动距离需要复原

    const verified = stddev !== 0; // 简单验证下拖动轨迹，为零时表示Y轴上下没有波动，可能非人为操作
    if (verified) {
      let result = `${realLeft}:${this.captchaImage.y}`;
      try {
        const res = await captchaCheck(
          this.appid,
          this.suid,
          this.reqId,
          result
        );
        if (res) {
          if (res.code === 200) {
            this.token = res.data;
            addClass(this.sliderContainer, 'sliderContainer_success');
            typeof this.options.onSuccess === 'function' &&
              this.options.onSuccess(res.data.token);
          } else if (res.code !== 200 && res.action === 'close') {
            addClass(this.sliderContainer, 'sliderContainer_fail');
            typeof this.options.onFail === 'function' &&
              this.options.onFail(res.msg);

            setTimeout(() => {
              this.close();
            }, 800);
          } else {
            addClass(this.sliderContainer, 'sliderContainer_fail');
            typeof this.options.onFail === 'function' &&
              this.options.onFail(res.msg);
            setTimeout(() => {
              this.resetPosition();
            }, 800);
          }
        } else {
          throw new Error();
        }
      } catch (error) {
        // 风控服务挂掉，接口没有返回的情况
        typeof this.options.onFail === 'function' &&
          this.options.onFail({
            err: error,
            msg: 'check network request error',
            code: 12306,
          });
      }
    } else {
      addClass(this.sliderContainer, 'sliderContainer_fail');
      // this.changeTopText('请拖动滑块对齐缺口')
      typeof this.options.onFail === 'function' && this.options.onFail();
      this.resetPosition();
    }
  }

  // 顶部提示语操作
  changeTopText(text = '', color = 'rgb(0, 0, 0)') {
    if (text) {
      this.verifyTip.innerText = text;
    }
    if (color) {
      this.verifyTip.style.color = color;
    }
  }

  // 刷新
  refresh() {
    this.resetPosition();
    this.createCaptcha();
  }

  // 验证码复位
  resetPosition() {
    this.slider.style.left = 0;
    this.blockImg.style.left = 0;
    // typeof this.options.onSuccess === 'function' && this.options.onReset()
    removeClass(this.sliderContainer, 'sliderContainer_fail');
    removeClass(this.sliderContainer, 'sliderContainer_success');
  }

  close() {
    this.isPainting = false;
    if (this.$element) {
      // this.$element.remove();
      // this.$element = null
      this.$element.style.display = 'none';
    }
    typeof this.options.onSuccess === 'function' && this.options.onClose();
    document.removeEventListener('mousemove', this.handleDragMove);
    document.removeEventListener('touchmove', this.handleDragMove);
    document.removeEventListener('mouseup', this.handleDragEnd);
    document.removeEventListener('touchend', this.handleDragEnd);
  }
}
